import React from 'react'
import PropTypes from 'prop-types'
import SwitchButton from '../../FormComponents/SwitchButton/Switch'
import { page as pageIndex } from '../../../globals'

class AlertsByRecord extends React.PureComponent {
  returnSubjectRows = () => {
    const { trackData, updateData, type } = this.props
    const { columnTitle } = this.returnTitle(type)
    return subjects.map((item, i) => {
      const className = trackData[type].radio[item.id]
        ? 'alert-row-record'
        : 'alert-row-record grey-alert-rows'
      if (!trackData[type].radio[item.id]) {
        trackData[type].radio[item.id] = false
      }
      return <div key={i} className={className}>
        <div className="alerts-col alert-record-sub allow-click">
          <SwitchButton
            text="Subscribed"
            location={{ page: pageIndex.dashboard, field: type }}
            id={item.id}
            isEnabled={trackData[type].radio[item.id]}
            updateData={updateData}
          />
        </div>
        {this.returnRecords(columnTitle, item)}
        <div className="alerts-col alert-record-sub small-column-record">
          <div className="track-green-button record-detail-btn">show detail</div>
        </div>
      </div>
    })
  }

  returnRecords = (type, itemData) => {
    switch (type) {
      case 'L':
        return <React.Fragment>
          <div className="alerts-col alert-record-sub small-column-record">{itemData.bill}</div>
          <div className="alerts-col alert-record-sub small-column-record">{itemData.session}</div>
          <div className="alerts-col alert-record-sub summary-sub">{itemData.summary}</div>
        </React.Fragment>
      case 'R':
        return <React.Fragment>
          <div className="alerts-col alert-record-sub very-small-column-record">{itemData.state}</div>
          <div className="alerts-col alert-record-sub small-column-record">{itemData.title}</div>
          <div className="alerts-col alert-record-sub small-column-record citation">{itemData.citation}</div>
          <div className="alerts-col alert-record-sub summary-sub sub-small">{itemData.summary}</div>
        </React.Fragment>
      case 'O':
        return <React.Fragment>
          <div className="alerts-col alert-record-sub small-column-record">{itemData.locality}</div>
          <div className="alerts-col alert-record-sub small-column-record">{itemData.title}</div>
          <div className="alerts-col alert-record-sub summary-sub">{itemData.summary}</div>
        </React.Fragment>
    }
  }

  returnTitle = (type) => {
    let title
    let subTitle
    let columnTitle
    switch (type) {
      case 'legisRecordAlerts':
        title = 'Legislative'
        subTitle = 'bills'
        columnTitle = 'L'
        break
      case 'regsRecordAlerts':
        title = 'Regulatory'
        subTitle = 'regulations'
        columnTitle = 'R'
        break
      case 'localRecordAlerts':
        title = 'Local Legislative'
        subTitle = 'local legislation'
        columnTitle = 'O'
        break
    }
    return { title, subTitle, columnTitle }
  }

  render () {
    const { type } = this.props
    const { title, subTitle, columnTitle } = this.returnTitle(type)
    return <div className="alert-category-body custom-scroll">
      <div className="category-alerts-title">{title} Alerts by Record</div>
      <div className="category-alerts-subtitle">Modify e-mail alert settings for specific {subTitle}.</div>
      <div className="rows-wrapper">
        <div className="alert-title-wrapper">
          {column[columnTitle].map((item, i) => {
            return <div key={i} className={`alerts-col title alert-record-sub ${item.className}`}>{item.title}</div>
          })}
        </div>
        {this.returnSubjectRows()}
      </div>
    </div>
  }

  static propTypes = {
    trackData: PropTypes.object,
    updateData: PropTypes.func,
    type: PropTypes.string
  }
}

export default AlertsByRecord

const column = {
  L: [
    { title: 'Subscribe', className: '' },
    { title: 'Bill', className: 'small-column-record' },
    { title: 'Session', className: 'small-column-record' },
    { title: 'Summary', className: 'summary-sub' },
    { title: 'Detail', className: 'small-column-record' }
  ],
  R: [
    { title: 'Subscribe', className: '' },
    { title: 'State', className: 'very-small-column-record' },
    { title: 'Title', className: 'small-column-record' },
    { title: 'Citation', className: 'small-column-record citation' },
    { title: 'Summary', className: 'summary-sub sub-small' },
    { title: 'Detail', className: 'small-column-record' }
  ],
  O: [
    { title: 'Subscribe', className: '' },
    { title: 'Locality', className: 'small-column-record' },
    { title: 'Title', className: 'small-column-record' },
    { title: 'Summary', className: 'summary-sub' },
    { title: 'Detail', className: 'small-column-record' }
  ]
}
const subjects = [
  {
    bill: 'SB 237',
    session: '2017-2018',
    summary: 'An introduced: Amends the Enviromental Pretection Act.',
    id: 'sub1',
    state: 'VT',
    title: 'Rules for Administrative Citations and Penalties and Debarment',
    citation: '24 010 005',
    locality: 'AZ: Tempe'
  },
  {
    bill: 'SB 239',
    session: '2017-2018',
    summary: 'An introduced: Amends the Enviromental Pretection Act.',
    id: 'sub2',
    state: 'CA',
    title: 'Record Title',
    citation: '24 010 005',
    locality: 'VA: Reston'
  }
]



// WEBPACK FOOTER //
// ./src/components/ManagementEmailAlerts/components/AlertsByRecord.js